import { makeStyles } from "@material-ui/core";

export const useVeracityEngineStyles = makeStyles(() => ({
    title: {
        paddingBottom: 4
    },
    switch: {
        float: "right"
    }
}));
